// The shared OFB/OPIN HTTP protocol vocabulary.

/**
 * Canonical FAPI / OFB / OPIN protocol HTTP header names.
 *
 * This frozen object is the single source of truth for the wire header strings.
 * Schemas and middleware key off these constants so the literal values and the
 * validation shape cannot drift apart.
 */
export const FAPI_HEADERS = {
  interactionId: 'x-fapi-interaction-id',
  authDate: 'x-fapi-auth-date',
  customerIpAddress: 'x-fapi-customer-ip-address',
  idempotencyKey: 'x-idempotency-key',
} as const;

/** The request method verbs, for owners that build their own schema from them. */
export const HTTP_METHODS = ['GET', 'POST', 'PUT', 'PATCH', 'DELETE'] as const;

/** The path every HTTP process serves its aggregate activity on, for the runtime-CD idle scaler. */
export const HTTP_POWER_ACTIVITY_PATH = '/healthz/activity';

/** Shared OFB/OPIN administrative monitoring vocabularies. */
export const METRICS_PERIODS = ['CURRENT', 'ALL'] as const;

export const DISCOVERY_STATUS_CODES = [
  'OK',
  'PARTIAL_FAILURE',
  'UNAVAILABLE',
  'SCHEDULED_OUTAGE',
] as const;
